import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronLeftSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 12,
	viewBox: "0 0 8 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.01398 11.4282L7.42798 10.0142L3.42798 6.01522L7.42798 2.01422L6.01398 0.600223L2.01298 4.60022L0.599978 6.01522L2.01298 7.42822L6.01398 11.4282Z",
		fill: "#005AA0"
	})]
});
const ForwardRef = forwardRef(SvgChevronLeftSmall);
export { ForwardRef as ReactComponent };
